// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__12QtF","search":"Settings_search__3UbQA","filter":"Settings_filter__WJ79v"};